import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react'

type ContactModalContextValue = {
  isOpen: boolean
  openContact: () => void
  closeContact: () => void
}

const ContactModalContext = createContext<ContactModalContextValue | undefined>(undefined)

export function ContactModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openContact = useCallback(() => setIsOpen(true), [])

  const closeContact = useCallback(() => setIsOpen(false), [])

  const value = useMemo(
    () => ({ isOpen, openContact, closeContact }),
    [isOpen, openContact, closeContact],
  )

  return <ContactModalContext.Provider value={value}>{children}</ContactModalContext.Provider>
}

export function useContactModal() {
  const ctx = useContext(ContactModalContext)
  if (!ctx) throw new Error('useContactModal must be used within a ContactModalProvider')
  return ctx
}


